import { isEmpty } from 'lodash';
import { useCallback, useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

import { availableSearchParams } from '../../services/urlParams/urlParams';
import { urlParamHook } from '../../services/urlParams/urlParamsService';
import useAnalyticStore from '../../store/analyticStore/useAnalyticStore';

const SetupParamsGuard = ({ children }: { children: JSX.Element }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const { sendLandedWithParametersAnalytics } = useAnalyticStore();

  const resetSearchParams = useCallback(
    (param: string) => {
      searchParams.delete(param);
      setSearchParams(searchParams, { replace: true, state: location.state });
    },
    [searchParams, setSearchParams, location.state],
  );

  const urlParamHandler = useCallback(
    (key: any) => {
      const valueFromParams = searchParams.get(key);
      const { saveParam } = urlParamHook(key);
      saveParam(valueFromParams);
      resetSearchParams(key);
    },
    [resetSearchParams, searchParams],
  );

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const entries = Object.fromEntries(searchParams.entries());

    if (isEmpty(entries)) {
      return;
    }

    sendLandedWithParametersAnalytics(
      'LandedWithParameters',
      window.location.href,
      window.location.host,
      window.location.pathname,
      entries,
    );
  }, []);

  useEffect(() => {
    availableSearchParams.forEach(urlParamHandler);
  }, []);

  return children;
};

export default SetupParamsGuard;
